import React from 'react';
import { useDispatch } from 'react-redux';
import RBForm from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { useTranslation } from 'react-i18next';
import { Form, Field } from 'react-final-form';
import arrayMutators from 'final-form-arrays';
import { Select } from '@fikasio/react-ui-components';
import {
  useGetOrganizationsQuery,
  useAddMemberToOrganizationMutation,
  useUpdateMemberInOrganizationMutation,
} from 'services/organizations/api';
import { clearPaneContent } from 'services/pane/slice';
import 'components/UI/Form.css';

interface MemberPaneProps {
  id: string;
  organizationId: string;
}

const MemberPane = ({
  id,
  organizationId,
}: MemberPaneProps) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { data: organizations } = useGetOrganizationsQuery();

  const [createMember] = useAddMemberToOrganizationMutation();
  const [updateMember] = useUpdateMemberInOrganizationMutation();

  const organization = (organizations || []).find(e => e.id === organizationId);
  const member = organization?.members.find(f => f.id === id);

  const onSubmit = async values => {
    const formData = values;
    if (id !== 'NEW') {
      updateMember({
        organizationId,
        id,
        ...formData,
      })
        .then(() => dispatch(clearPaneContent()));
    } else {
      createMember({
        organizationId,
        ...formData,
      })
        .then(() => dispatch(clearPaneContent()));
    }
  };

  return (
    <Form
      initialValues={member}
      mutators={{ ...arrayMutators }}
      onSubmit={onSubmit}
      render={({ handleSubmit }) => (
        <form onSubmit={handleSubmit}>
          <div>
            <label className="form-label">{t('name')}</label>
            <Field
              component="input"
              className="form-control"
              name="name"
            />
          </div>
          <div>
            <label className="form-label">{t('type')}</label>
            <Field
              component={
                ({ input }) => {
                  return (
                    <Select
                      defaultValue={input.value}
                      onChange={value => input.onChange(value)}
                      options={[
                        { label: t('boolean'), value: 'BOOLEAN' },
                        { label: t('number'), value: 'NUMBER' },
                        { label: t('text'), value: 'STRING' },
                      ]}
                    />
                  )
                }
              }
              name="type"
            />
          </div>
          <div>
            <label className="form-label">{t('required')}</label>
            <Field
              component="input"
              className="form-control"
              name="isRequired"
              type="checkbox"
            >
              {
                props => (
                  <div>
                    <RBForm.Check
                      {...props.input}
                      type="switch"
                    />
                  </div>
                )
              }
            </Field>
          </div>
          <div style={{ float: 'right', bottom: 0, paddingBottom: 15 }}>
            {
              member
                ? <Button type="submit" variant="success">{t('save')}</Button>
                : <Button type="submit" variant="success">{t('create')}</Button>
            }
          </div>
        </form>
      )}
    />
  );
};

export default MemberPane;
